import { NavLink } from "react-router-dom";
import OverViewIcon from "../../components/OverViewIcon";
import AlertIcon from "../../components/AlertIcon";
import StatusIcon from "../../components/StatusIcon";

const Header = ({ messageDatalength }) => {
  const greyBackground = {
    color: "rgba(204, 219, 240, 0.72)",
    background: "rgba(137, 162, 196, 0.2)",
    borderRadius: "0px 8px 8px 0px",
  };
  const noBackGround = { color: "rgba(204, 219, 240, 0.72)" };
  const linkStyle = ({ isActive }) =>
    isActive ? greyBackground : noBackGround;

  return (
    <header className="header flex items-end bg-light-8 h-screen w-[144px]">
      <nav className="flex flex-col items-center text-light-56 w-full">
        <NavLink
          to="/Status"
          className="flex justify-center items-center w-full h-[180px]"
          style={linkStyle}
        >
          <div className="flex flex-col items-center">
            <StatusIcon header="Sensors" />
          </div>
        </NavLink>
        <NavLink
          to="/Alerts"
          className="flex justify-center items-center w-full h-[180px]"
          style={linkStyle}
        >
          <div className="flex flex-col items-center">
            <AlertIcon messagelength={messageDatalength} header="Alerts" />
          </div>
        </NavLink>
        <NavLink
          end
          to="/"
          className="flex justify-center items-center w-full h-[180px]"
          style={linkStyle}
        >
          <div className="flex flex-col items-center">
            <OverViewIcon header="Overview" />
          </div>
        </NavLink>
      </nav>
    </header>
  );
};

export default Header;